// These are used as feature flags
export enum OrgPermission {
  Apideck = 'apideck',
  GeminiModels = 'geminiModels',
  RelativityUsage = 'relativityUsage',
  AdminApproval = 'adminApproval',
  Require2FANonSSO = 'require2faNonSSO',
  Feedback = 'feedback',
  UsePropelAdminRoleAsDefault = 'usePropelAdminRoleAsDefault',
  KimFileUpload = 'kimFileUpload',
  MentionFolders = 'mentionFolders',
}

// Keep these legacy JSONB values in org rows until chronos-ml stops reading them.
// They are intentionally not part of OrgPermission any more.
export const LEGACY_ML_ORG_PERMISSIONS = ['anthropicModels', 'inconsistencies'] as const;

export function withLegacyMlOrgPermissions(permissions: OrgPermission[]): string[] {
  return [...new Set([...permissions, ...LEGACY_ML_ORG_PERMISSIONS])];
}
